var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { generateUUID, formatDateObjectToString } from "syf-js-utilities";
import { getItem, setItem } from "./requestStorage.js";
import { getItem as getItem$1, setItem as setItem$2 } from "./responseStorage.js";
import { getItem as getItem$2, setItem as setItem$1 } from "./alternatePaymentMethodsStorage.js";
const createECheckResponse = (paymentMethodMutationVariables) => {
  const { paymentMethod } = paymentMethodMutationVariables;
  if (!paymentMethod) {
    throw new Error("Payment method not set");
  }
  const {
    "cipher.bankAccountNumber": accountNumber,
    "cipher.bankRoutingNumber": routingNumber,
    type
  } = paymentMethod;
  return {
    bankAccountNumberLast4: accountNumber.slice(-4),
    bankRoutingNumber: routingNumber,
    type,
    bankChannel: "DIGITAL"
  };
};
const createPaymentCardResponse = (paymentMethodMutationVariables) => {
  const { paymentCardInfo } = paymentMethodMutationVariables;
  if (!paymentCardInfo) {
    throw new Error("Payment card info not set");
  }
  const { "cipher.cardNumber": cardNumber } = paymentCardInfo;
  return {
    cardNumberLast4: cardNumber == null ? void 0 : cardNumber.slice(-4)
  };
};
const setResponse = (id, payload) => {
  const { paymentMedium } = payload;
  let paymentResponse;
  switch (paymentMedium) {
    case "E_CHECK":
      paymentResponse = createECheckResponse(payload);
      break;
    case "CREDIT_CARD":
    case "PINLESS_DEBIT_CARD":
      paymentResponse = createPaymentCardResponse(payload);
      break;
    default:
      throw new Error(`Invalid or undefined payment medium: ${paymentMedium}`);
  }
  const response = __spreadProps(__spreadValues({}, paymentResponse), {
    id,
    dateCreated: formatDateObjectToString(/* @__PURE__ */ new Date()),
    rejected: false,
    paymentMedium
  });
  setItem$2(id, response);
};
const mutationFnFactory = (config, keyProps) => {
  return (payload) => new Promise((resolve, reject) => {
    const id = generateUUID();
    const { accountId } = keyProps;
    if (getItem(id)) {
      reject(new Error("Payment method already exists"));
      return;
    }
    setItem(id, payload);
    setResponse(id, payload);
    const paymentMethod = getItem$1(id);
    const accountPaymentMethods = getItem$2(accountId) || [];
    setItem$1(accountId, [
      ...accountPaymentMethods,
      paymentMethod.id
    ]);
    resolve({
      paymentMethod
    });
  });
};
export {
  mutationFnFactory as default
};
//# sourceMappingURL=mutation.js.map
